export const gradeAPIs = {
  assignedGrades: (userId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${userId}/assignSubjects`,
};

export const ChapterAPIs = {
  fetchChapters: (staffId, sectionId, subjectId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/sections/${sectionId}/subjects/${subjectId}/chapters`,
};

export const TopicAPIs = {
  fetchTopics: (staffId, sectionId, subjectId, chapterId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/sections/${sectionId}/subjects/${subjectId}/chapters/${chapterId}/topics`,
};

export const LessonPlanAPIs = {
  createLessonPlan: (staffId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans`,
  fetchLessonPlans: (staffId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans`,
  fetchGroupedPlans: (staffId, query) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans/group?${query}`,
  editLessonPlan: (staffId, planId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans/${planId}`,
  deleteLessonPlan: (staffId, planId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans/${planId}`,
  addColumn: (staffId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans/cols`,
  searchModules: (name) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/modules/search-modules?name=${name}`,
  getModule: (id) => `${process.env.REACT_APP_ORIGIN}/api/v1/modules/${id}`,
  //Cell
  addCell: (staffId, planId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans/${planId}/cells`,
  updateCells: (staffId, planId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans/${planId}/cells`,
  updateCell: (staffId, planId, cellId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans/${planId}/cells/${cellId}`,
  removeCells: (staffId, planId) =>
    `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${staffId}/lessonplans/${planId}/cells`,
};
